<template>
  <div class="addViolationNotice">
    <el-dialog
      title="新增违规公示"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1100px"
      :before-close="handleClose"
    >
      <div class="form_box">
        <el-form
          ref="formInline"
          :model="formInline"
          :rules="rules"
          label-width="140px"
        >
          <el-form-item label="违规公示标题" prop="title">
            <el-input
              v-model="formInline.title"
              maxlength="50"
              style="width: 350px"
              placeholder="请输入违规公示标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="违规公示内容" prop="content">
            <QuillEditor
              ref="editorRef"
              :value="formInline.content"
              v-model="formInline.content"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleAffirm"
          >发 布</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addIllegalPublicity } from "@/api/organization/violationNotice.js";
import QuillEditor from "@/components/QuillEditor/index.vue";
export default {
  components: {
    QuillEditor,
  },
  data() {
    return {
      dialogVisible: false,
      formInline: {
        title: "",
        content: "",
      },
      rules: {
        title: [
          { required: true, message: "请输入违规公示标题", trigger: "blur" },
        ],
        content: [{ required: true, message: "请输入违规公示内容" }],
      },
    };
  },
  methods: {
    // 初始化
    init() {
      Object.assign(this.$data, this.$options.data());
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formInline.clearValidate();
      });
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
    },
    // 确认
    handleAffirm() {
      this.$refs["formInline"].validate((valid) => {
        if (valid) {
          addIllegalPublicity({ ...this.formInline }).then((res) => {
            if (res.code === 0) {
              this.$parent.refresh();
              this.$message({
                type: "success",
                message: "添加成功",
              });
              this.dialogVisible = false;
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.addViolationNotice {
}
</style>